// ── Registro de Radio — 4 pasos ultra simples ──
// Bloque 26 — Sin tecnicismos, sin frecuencias manuales

export interface RadioRegistrationStep {
  id: number;
  number: string;
  title: string;
  description: string;
  icon: string;
}

export const registrationSteps: RadioRegistrationStep[] = [
  {
    id: 1,
    number: '01',
    title: 'Registrar Radio',
    description: 'Creá tu perfil con nombre, país y categoría. Sin formularios largos. Sin letra chica.',
    icon: 'ri-radio-line',
  },
  {
    id: 2,
    number: '02',
    title: 'Frecuencia RFW',
    description: 'Recibí tu frecuencia automáticamente al registrarte. Sin elegir. Sin pagar. Es tuya.',
    icon: 'ri-radar-line',
  },
  {
    id: 3,
    number: '03',
    title: 'Configurar Streaming',
    description: 'Conectá tu stream con un solo enlace. Probá la conexión y listo. Sin configuraciones técnicas.',
    icon: 'ri-broadcast-line',
  },
  {
    id: 4,
    number: '04',
    title: 'Comenzar a Crecer',
    description: 'Tu radio ya está al aire en RFW. Perfil público, QR, comunidad. Todo listo para tus oyentes.',
    icon: 'ri-rocket-line',
  },
];